import { Component, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbDate, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CompanyParamsService } from '../../../core/services/company-params.service';

import * as moment from 'moment';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnChanges {

  @ViewChild("d", { static: true }) d!: NgbInputDatepicker;

  @Input() minD!:Date;

  minDate!: NgbDate;
  maxDate!: NgbDate;
  navigation = 'arrows';
  today: Date = new Date();

  @Output() dateSelected: EventEmitter<Date> = new EventEmitter();
  secondaryCompanyColor = this.companyParamsService.getSecundaryColor();
  disabledRanges: { start: NgbDate, end: NgbDate }[] | undefined = this.companyParamsService.getFiltersSearchCalendarRanges();

  constructor(
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    public companyParamsService: CompanyParamsService,
    private elRef: ElementRef
  ) {

  }

  ngOnInit(): void {
    this.minDate = this.toNgbDate(new Date());
    const maxDateAux = new Date();
    maxDateAux.setFullYear(maxDateAux.getFullYear() + 1);
    this.maxDate = this.toNgbDate(maxDateAux);
    this.elRef.nativeElement.style.setProperty('--sec-company-color', '#' + this.secondaryCompanyColor);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['minD']) {
      this.minDate = this.toNgbDate(this.minD);
      this.today = this.minD;
    }
  }

  onDateFromSelect(date: NgbDateStruct) {
    // control when the user choose the same value preloaded
    if (this.today.getTime() === this.toDate(date).getTime()) {
      this.today = new Date();
      this.cdRef.detectChanges();
    }
    this.today = this.toDate(date);
    this.dateSelected.emit(this.today);
  }

  get formattedDate(): string {
    if (!this.today) {
      return `missing start date`;
    }
    const fromFormatted = moment(this.today).format('MMMM D, YYYY');
    return `${fromFormatted}`;
  }


  getYearMonthDayFromDate(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Los meses en JavaScript se cuentan desde 0 (enero) hasta 11 (diciembre)
    const day = date.getDate();

    return { year, month, day };
  }

  // from date  to   string  Result: "September 1, 2023"
  formatDate(date: Date): string {
    const options = { month: 'long', day: 'numeric', year: 'numeric' } as Intl.DateTimeFormatOptions;
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  toNgbDate(date: Date): NgbDate {
    const ngbDate: NgbDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    return ngbDate;
  }

  toDate(dateStruct: NgbDateStruct): Date {
    return dateStruct ? new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day) : new Date();
  }

  isDateDisabled = (date: NgbDate, current: { year: number, month: number } | undefined) => {
    for (const range of this.disabledRanges!) {
      if (date.after(range.start) && date.before(range.end) || date.equals(range.start) || date.equals(range.end)) {
        return true; // Date is within a disabled range
      }
    }
    return false; // Date is not within any disabled range
  };

}
